module.exports = __webpack_public_path__ + "static/media/download-01.4906f0c0.svg";